import { render, staticRenderFns } from "./ProjectDefault.vue?vue&type=template&id=49fdb127"
import script from "./ProjectDefault.vue?vue&type=script&lang=js"
export * from "./ProjectDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports